import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { ThemeProvider } from "@mui/material/styles";
import theme from "../ThemeSettings/Theme";

type ErrorPageProps = {
  moveLeftBy?: number;
  goTo?: string;
  refreshInsteadOfBack?: boolean;
  checkYourInputsandRefresh?: boolean;
};

function ErrorPage(props: ErrorPageProps) {
  const navigate = useNavigate();
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>Salus | Error</title>
      </Helmet>
      <Stack
        sx={{
          width: `calc(100% - ${props.moveLeftBy}px)`,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          pt: 10,
          gap: 2,
        }}
      >
        <Typography variant="h3">Oops! Something went wrong.</Typography>
        <Typography variant="body1">
          We're sorry for the inconvenience.
          {props.checkYourInputsandRefresh
            ? " If you've recently entered new information or changed some inputs, we encourage you to double-check the values. Or, please reload the page to try again."
            : props.refreshInsteadOfBack
            ? " Please reload the page to try again."
            : " Please try again or go back to the previous page."}
        </Typography>
        <Button
          size="large"
          color="warning"
          variant="contained"
          onClick={() =>
            props.goTo
              ? navigate(props.goTo)
              : props.refreshInsteadOfBack || props.checkYourInputsandRefresh
              ? navigate(0)
              : navigate(-1)
          }
        >
          {props.refreshInsteadOfBack || props.checkYourInputsandRefresh ? "Reload" : "Go Back"}
        </Button>
        <Typography variant="body2">If the problem persists, please contact us.</Typography>
      </Stack>
    </ThemeProvider>
  );
}

export default ErrorPage;
